export interface IValidation {
    type: boolean,
    gender: boolean,
    firstName: boolean,
    lastName: boolean,
    country: boolean,
    addressLine1: boolean,
    city: boolean,
    stateProvince: boolean,
    postalCode: boolean,
    phoneNumberPrimary: boolean,
    emailPrimary: boolean,
    emailSecondary: boolean,
    birthDate: boolean
}